import { combineReducers } from 'redux';

import currentUser from './reducers/currentUser';
import currentSession from './reducers/currentSession';
import currentCompany from './reducers/currentCompany';
import currentTempSetting from './reducers/currentTempSetting';
import currentObject from './reducers/currentObject';
import currentLayout from './reducers/currentLayout';
import currentNavigationMenu from './reducers/currentNavigationMenu';
import currentToast from './reducers/currentToast';
import currentUiSettings from './reducers/currentUiSettings';
import currentRoles from './reducers/currentRoles';
import generalCountry from './reducers/generalCountry';
import generalProduct from './reducers/generalProduct';
import legalForm from './reducers/legalForm';
import legalNature from './reducers/legalNature';
import typeOfSubject from './reducers/typeOfSubject';



const reducer  = combineReducers({  
  currentUser,
  currentLayout,
  currentSession,
  currentCompany,
  currentTempSetting,  
  currentObject,
  currentNavigationMenu,
  currentToast,
  currentUiSettings,
  currentRoles,
  generalCountry,
  generalProduct,
  legalForm,
  legalNature,
  typeOfSubject
})

export default reducer; 